module.exports = new __parcel__URL__("shop_battlepass_season_0_image.7272e083.png").toString();